export const SYSTEM_ACTIONS = {
  GROUP_JOIN: 'group:join',
  GROUP_ENTRY: 'group:entry',
  FINISHED_CONVERSATION: 'conversation:finished',
  VERIFICATION_REQUEST: 'verification_request',
  FALSE_ALARM_CONFIRMED: 'false_alarm_confirmed',
  DURESS_CONFIRMED: 'duress_confirmed',
  VERIFICATION_INVALID_CODE: 'verification_invalid_code',
};
